export const getNearestNumber = (num: number, array: number[]) =>
	array.reduce((nearest, current) => (Math.abs(current - num) < Math.abs(nearest - num) ? current : nearest), 0);
